import { format } from 'date-fns';

const isBlank = (object: any) => {
  if (object == null) return true;
  if (typeof object === 'string') return object.trim().length === 0;
  if (typeof object === 'object')
    return Object.values(object).find((value) => value !== '' && value !== null) === undefined;
};

const isNotNullOrUndefined = (object: any) => {
  return !(object == null); // Don't touch the double equals here! (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#loose_equality_using)
};

const isNullOrUndefined = (object: any) => {
  return object == null; // Don't touch the double equals here! (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#loose_equality_using)
};

const getFormattedDate = (date: string | null | undefined, short: boolean) => {
  let formatted = '';
  if (!date) return formatted;
  try {
    formatted = format(new Date(date), short ? 'dd.MM.yyyy' : 'dd.MM.yyyy HH:mm:ss');
  } catch (error) {
    console.error(error);
  }
  return formatted;
};

const shortText = (input: string, maxLength: number) => {
  return input.length > maxLength ? input.substring(0, maxLength - 3) + '...' : input;
};

const Helper = {
  isBlank,
  isNullOrUndefined,
  isNotNullOrUndefined,
  getFormattedDate,
  shortText,
};

export default Helper;
